// extracted by mini-css-extract-plugin
export var videoContentArea = "videoWithImage-module--video-content-area--91127";
export var videoImage = "videoWithImage-module--video-image--c9e36";
export var videoWithImage = "videoWithImage-module--video-with-image--ff3ec";
export var videoWrapper = "videoWithImage-module--video-wrapper--6be1b";